module.exports = __webpack_public_path__ + "img/content5-2.da033be1.png";